import React, { useEffect } from "react";
import HeaderBar from "components/v1/HeaderBar";
import Navigation from "components/v1/Navigation";
import { Outlet, useNavigate, useLocation } from "react-router";
import { ContainerView } from "router/styles";
import useUser from "hooks/useUser";
import authService from "services/authService";

function Container() {
  const location = useLocation();
  const { getToken } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    const token = getToken();
    const isTokenExpired = token && authService.IsTokenAboutToExpired();
    if (!token || isTokenExpired) {
      navigate("/corporate");
    }
  }, [location]);

  return (
    <ContainerView style={{ backgroundColor: '#FFFFFF' }}>
      <Navigation />
      <section>
        <HeaderBar />
        <section
          style={{
            padding: "36px 0px",
            maxWidth: "1600px",
          }}
        >
          <Outlet />
        </section>
      </section>
    </ContainerView>
  );
}

export default Container;
